import * as yup from "yup";
import { validationConfirmNewPasswordL, validationNewPassword, validationNotEmpty, } from "./defaultValidations";

export default yup.object({
    oldPassword: validationNotEmpty("Password"), 
    password: validationNewPassword("Password"),
    confirmPassword: validationConfirmNewPasswordL("Confirm Password"),
});